export function capitalize(str: string): string { // AKA ucfirst
  return str.substring(0, 1).toUpperCase() + str.slice(1);
}
